import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { searchAction } from '../../../../../actions/searchActions';
import { manageSocialRoom } from '../../../../../actions/userActions';
import { CloseIcon } from '../../../../../assets/icons';
import { Translate } from '../../../../../language';
import Button from '../../../../../utils/components/Button/Button';
import ImageNameDescription from '../../../../../utils/components/ImageNameDescription/ImageNameDescription';
import InputSearch from '../../../../../utils/components/InputSearch/InputSearch';
import localStorage from '../../../../../utils/hooks/useLocalStorage';
import style from './AdminRoom.module.css'
const AdminInviteRoom = ({ room, usersToInvite, setUsersToInvite, }) => {
    const { isLoadingSearchList, searchList } = useSelector(state => state.users)
    const dispatch = useDispatch()
    return (
        <div className={style.content_right_container}>
            <InputSearch
                placeholder={Translate('searchPalcheholder', 'es')}
                classNameContent=""
                searchData={(value) => dispatch(searchAction(value, "userAndFranchises"))}
                isLoading={isLoadingSearchList}
                renderData={searchList && searchList.userAndFranchises && <>
                    {
                        searchList.userAndFranchises[0].users.map(user => {
                            let data = user;
                            if (user.warehouseID) {


                                data._id = user.warehouseID
                                data.lastname = null

                            }
                            if (user.representativeID) {
                                if (user.representativeID.state ===2) {
                                    data._id = user.representativeID._id
                                    data = user.representativeID
                                }
                            }
                            if (user._id !== localStorage().getItem('idProfile') && (usersToInvite.find(userToInvite => userToInvite._id === user._id) === undefined)) {
                                return <ImageNameDescription
                                    key={data._id}
                                    onClick={(e) => {
                                        e.preventDefault(); e.stopPropagation();
                                        setUsersToInvite(users => {
                                            return [...users, user]
                                        })
                                    }}
                                    srcImage={user.picture && user.picture.url ? user.picture.url.small : user.picture}
                                    firstName={data.name}
                                    secondName={data.lastname}
                                    description={null}
                                />
                            }
                        }

                        )
                    }
                    {
                        searchList.userAndFranchises[0].franchises.map(franchise =>
                            (franchise._id !== localStorage().getItem('idProfile') &&
                                (usersToInvite.find(userToInvite => userToInvite._id === franchise._id) === undefined)

                            ) && (
                                <ImageNameDescription
                                    key={franchise._id}
                                    onClick={(e) => {
                                        e.preventDefault(); e.stopPropagation();
                                        setUsersToInvite(users => {
                                            return [...users, {
                                                _id: franchise._id,
                                                name: franchise.socialReason,
                                                picture: franchise.picture && franchise.picture.url ? franchise.picture.url.small : franchise.picture,
                                                lastname: null,
                                            }]
                                        })
                                    }}
                                    srcImage={franchise.picture && franchise.picture.url ? franchise.picture.url.small : franchise.picture}
                                    firstName={franchise.socialReason}

                                    description={null}
                                />
                            )
                        )
                    }


                </>
                }
            />
            <div style={{
                height: "65vh"
            }} className='scroll-menu'>
                {
                    usersToInvite.map(user => (
                        <div className={style.user_to_invite}>
                            <ImageNameDescription
                                type={style.user_to_invite_ind}
                                key={user._id}
                                onClick={(e) => {

                                }}
                                srcImage={user.picture && user.picture.url ? user.picture.url.small : user.picture}
                                firstName={user.name}
                                secondName={user.lastname}
                                description={null}
                            />
                            <div>
                                <CloseIcon
                                    onClick={(e) => {
                                        e.preventDefault(); e.stopPropagation();
                                        setUsersToInvite(users => {
                                            //return [...users, user]
                                            var prevStateDelete = users.filter(u => u._id !== user._id)

                                            return prevStateDelete
                                        })
                                    }}
                                    height={20} />
                            </div>
                        </div>
                    ))
                }
            </div>
            <div>
                <Button
                    onClick={() => {
                        usersToInvite.forEach(user => {
                            dispatch(manageSocialRoom({
                                chatRoomID: room._id,
                                entityID: user._id,
                                type: 1
                            })).then(() => {
                                setUsersToInvite([])
                            })
                        });

                    }}
                    text='Invitar'
                />
            </div>

        </div>)
};

export default AdminInviteRoom;
